import { Dot, type ColoredDotProps } from '../dot.component';

export const SuccessDot = ({ children, ...props }: ColoredDotProps) => (
  <Dot color='success' {...props}>
    <>{children}</>
  </Dot>
);
